<template>
  <div>
    <div class="head-box">
      <h4>商品分类管理</h4>
      <div class="c-flex c-flex-item">
        <el-input
          v-if="osg.has('Classify,search')"
          placeholder="请输入要查询的内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('Classify,new')"
          type="primary"
          @click.native="doNew()"
          class="c-m-l-10"
        >
          新建一级分类
        </el-button>
        <el-button
          v-if="osg.has('Classify,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': 1,
                'regex:name|string#and': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'classify',
                title: '商品分类'
              },
              { dynamic: true, preset: '1' }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter" v-if="osg.has('Classify,filter')">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          :data="fpi.data"
          ref="table"
          style="width: 100%"
          height="calc(100% - 10px)"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          row-key="_id"
          default-expand-all
          :tree-props="{ children: 'children' }"
        >
          <el-table-column label="排序" width="200px">
            <template slot-scope="scope">
              {{ scope.row.order }}
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
          <el-table-column
            v-if="osg.has('Classify,new') || osg.has('Classify,edit') || osg.has('Classify,remove')"
            label="操作"
            width="260px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="osg.has('Classify,new')"
                size="small"
                plain
                @click.native="doNew(scope.row)"
              >
                添加下级分类
              </el-button>
              <el-button
                v-if="osg.has('Classify,edit')"
                type="primary"
                size="small"
                plain
                @click.native="doEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="osg.has('Classify,remove')"
                type="danger"
                size="small"
                plain
                @click.native="doRemove(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="商品分类" :visible.sync="openDetail" :close-on-click-modal="false">
          <c-form
            :formData="formData"
            :fields="extFields"
            :options="options"
            ref="form"
            :upload="upload"
            labelWidth="100px"
            :area="area"
            @changeForm="osg.changeForm"
          >
            <template slot="type">
              <el-select
                v-model="formData.type"
                :disabled="formData.parentId == tenantId ? formData.children.length > 0 : true"
              >
                <el-option
                  v-for="item in options.commodityType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </c-form>
          <div slot="footer">
            <el-button type="primary" @click="doSave">确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'classify',
  data() {
    window.$this = this;
    return {
      tenantId: '',
      refresh: true,
      searchValue: '',
      fpi: {},
      extFields: [],
      openDetail: false,
      options: {},
      formData: { children: [] },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.getFields('classify', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    doInit(row) {
      this.openDetail = false;
      if (row) {
        this.formData = { parentId: row._id, type: row.type, children: [] };
      } else {
        this.formData = { parentId: this.tenantId, children: [] };
      }
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        _all: '1',
        parentId: this.tenantId,
        'is:state|integer#and': 1,
        'regex:name|string#or': this.searchValue,
        sortField: 'order',
        sortOrder: 'asc'
      };
      if (this.osg.has('Classify,filter')) {
        window.$that.getParams(params);
      }
      this.osg.setFpi(params);
      this.osg.ajax('/biz/classify/queryClassify.do', params, res => {
        // 渲染字段防止报错
        this.$util.renderExtFormFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew(row) {
      this.doInit(row);
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveFormatExtField(this.extFields, params);
        this.osg.ajax('/biz/classify/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(row) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('/biz/classify/remove.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('删除成功');
        });
      });
    }
  }
};
</script>
